// 参照元サイト
// https://nipponcolors.com/

export const colors = {
  BENIHI: '#F75C2F',
  FUJI: '#8B81C3',
  KUCHINASHI: '#F6C555',
  KURENAI: '#CB1B45',
  DODGERBLUE: '#1890ff',
  MIZUASAGI: '#66BAB7',
  NAE: '#86C166',
  RURI: '#005CAF',
  TSUYUKUSA: '#2EA9DF',
  YAMABUKI: '#FFB11B',
}
